import { Switch, Text } from '@mantine/core';
import React from 'react';

interface CustomSwitchProps extends React.ComponentProps<typeof Switch> {
  label?: string;
  inputProps?: any;
}

export function CustomSwitch(props: CustomSwitchProps) {
  const { label, checked, inputProps } = props;

  return (
    <div className="custom-switch-wrapper">
      <div className="print-hide">
        <Switch
          {...props}
          {...inputProps}
          mt={30}
          mb={30}
          radius={12}
          size={'md'}
          color={'dpkk-blue'}
          label={label}
        />
      </div>

      <div className="screen-hide">
        {label && (
          <Text size="sm" mt={10}>
            {label}
          </Text>
        )}
        <Text mt={4}>{checked ? 'ANO' : 'NE'}</Text>
      </div>
    </div>
  );
}
